module.exports = __webpack_public_path__ + "img/link-invalido.0a38972b.png";